/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivDocumentIdsAiDtoGen,
  MrfiktivDocumentRuleCheckControllerGetParamsGen,
  MrfiktivDocumentRuleCheckControllerGetUsageParamsGen,
  MrfiktivDocumentRuleCheckUsageViewModelGen,
  MrfiktivDocumentRuleCheckViewModelGen,
  MrfiktivPageViewModelGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class DocumentRuleCheck<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags document-rule-check
   * @name DocumentRuleCheckControllerAnalysesDocumentRulesForImages
   * @summary (Document rule check - CREATE) Schedules a document rule check
   * @request POST:/partner/{partnerId}/document-rule-check
   * @secure
   * @response `201` `MrfiktivDocumentRuleCheckViewModelGen` The Document Rule check viewmodel
   */
  documentRuleCheckControllerAnalysesDocumentRulesForImages = (
    partnerId: string,
    data: MrfiktivDocumentIdsAiDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivDocumentRuleCheckViewModelGen, any>({
      path: `/partner/${partnerId}/document-rule-check`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-rule-check
   * @name DocumentRuleCheckControllerGet
   * @summary (Document rule check - READ) Get all document rule checks
   * @request GET:/partner/{partnerId}/document-rule-check
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivDocumentRuleCheckViewModelGen)[] })`
   */
  documentRuleCheckControllerGet = (
    { partnerId, ...query }: MrfiktivDocumentRuleCheckControllerGetParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivDocumentRuleCheckViewModelGen[] }, any>({
      path: `/partner/${partnerId}/document-rule-check`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-rule-check
   * @name DocumentRuleCheckControllerGetUsage
   * @summary (Document rule check - READ) Get usage totals for a partner in a period
   * @request GET:/partner/{partnerId}/document-rule-check/usage
   * @secure
   * @response `200` `MrfiktivDocumentRuleCheckUsageViewModelGen` Usage totals for the partner in the requested period
   */
  documentRuleCheckControllerGetUsage = (
    { partnerId, ...query }: MrfiktivDocumentRuleCheckControllerGetUsageParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivDocumentRuleCheckUsageViewModelGen, any>({
      path: `/partner/${partnerId}/document-rule-check/usage`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags document-rule-check
   * @name DocumentRuleCheckControllerGetOne
   * @summary (Document rule checks - READ) Get a document rule check
   * @request GET:/partner/{partnerId}/document-rule-check/{documentRuleCheckId}
   * @secure
   * @response `200` `MrfiktivDocumentRuleCheckViewModelGen` The document rule check
   */
  documentRuleCheckControllerGetOne = (partnerId: string, documentRuleCheckId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivDocumentRuleCheckViewModelGen, any>({
      path: `/partner/${partnerId}/document-rule-check/${documentRuleCheckId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
}
